import React, { useEffect, useState } from "react";
import SpiderChart from "./spiderChart";
import BASE_URL from "../../components/config/appconfig";

const SpiderChartContainer = ({ assessmentId, firstAssessmentId }) => {
  const [chartData, setChartData] = useState({ labels: [], values: [] });
  const [firstChartData, setFirstChartData] = useState(null);
  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `${BASE_URL}/api/assessments/${assessmentId}/spider-chart`
        );
        if (!response.ok) throw new Error("API failed");
        const result = await response.json();
        if (!result.success) throw new Error(result.message || "Failed to fetch data");

        setChartData({ labels: result.labels, values: result.values });
        setRawData(result.data || []);
        
        if (firstAssessmentId && firstAssessmentId !== assessmentId) {
          const firstResponse = await fetch(
            `${BASE_URL}/api/assessments/${firstAssessmentId}/spider-chart`
          );
          if (firstResponse.ok) {
            const firstResult = await firstResponse.json();
            if (firstResult.success) {
               setFirstChartData({ labels: firstResult.labels, values: firstResult.values });
            }
          }
        } else {
          setFirstChartData(null);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (assessmentId) fetchChartData();
  }, [assessmentId, firstAssessmentId]);

  if (loading) return <p>Loading chart...</p>;
  if (error) return <p style={{ color: "red" }}>Error: {error}</p>;
  if (!chartData.labels.length) return <p>No data available</p>;

  return <SpiderChart chartData={chartData} rawData={rawData} firstChartData={firstChartData} />;
};

export default SpiderChartContainer;
